
(function($, window, document, s, undefined) {

// VARIABLES
var spinner;
var manualStateChange = true;

var s = {
    'bodySelector': 'body',
    'contactPageClass': 'contact',
    'openMobileSelector': '.sandwich.mobile',
    'openDesktopSelector': '.sandwich.desktop',
    'closeAjaxSelector': '.sandwich.xx',
    'closeButtonSelector': '.sandwich.xx',
    'moreSelector': '.more',
    'loadingSelector': '.loader',
    'loadMoreSelector': '.load-more',


    'lineSelector': '.sandwich .line',
    'pusherSelector': '#pusher',

    'newsRowSelector': '.news .related-item',
    'titleSelector': '.title',
    'lawyerRowSelector': '.lawyer-list .lawyer',
    'postListNewsSelector': '.post-list.news',
    'newsItemSelector': '.news-item',

    'listItemSelector' : 'a.ajax',

    'ajaxWrapperSocialSelector': '.ajax-wrapper .social-icons',
    'ajaxClickSelectors': 'a#bottom-nav, a.slider, a.item',

    'socialLinkSelector': '.social-link',
    'mobileMenuSelector': '#mobile-menu',
    'desktopMenuSelector': '#desktop-menu',
    'desktopMenuSlideSelector': '#desktop-menu-slide',
    'mainWrapperSelector': '#main-wrapper',
    'ajaxWrapperSelector': '.ajax-wrapper',
    'siteContentSelector': '#site-content',
    'heroBackgroundSelector': '#hero-background',
    'navbarMobileSelector': '#navbar-mobile',
    'mainContentSelector': '#main-content',
    'homeMainContentSelector': '.home #main-content',
    'articleBodySelector': '.article-body',
    'articleBodyScrollSelector': 'article-body-scroll',
    'verticalBannerSelector': '#vertical-banner',
    'horizontalBannerSelector': '#horizontal-banner',
    'bannerTextSelector': '.banner-text',
    'ajaxStoreSelector': '#ajax-store',

    'articleBodyOverflowSelector': '.article-body-overflow',
    'primaryArticleBodySelector': '#site-content .article-body',
    'ajaxArticleBodyOverflowSelector': '.ajax-wrapper .article-body-overflow',
    'ajaxArticleBodySelector': '.ajax-wrapper .article-body',

    'desktopMenuItemSelector': '#desktop-menu .menu-item',
    'relatedSelector': '.related',
    'backSelector': '.back',
    'sliderSelector': '.slider',
    'itemSelector': '.item',
    'googleMapSelector': '#google-map',

    'pushClass': 'push',
    'pushedClass': 'pushed',
    'openClass': 'open',
    'closeClass': 'close',
    'showClass': 'show',
    'hideClass': 'hide',
    'expandedClass': 'expanded',
    'slideClass': 'slide',
    'fadeInClass': 'fadeIn',
    'transformClass': 'transform',
    'scrollableClass': 'scrollable',
    'unscrollableClass': 'unscrollable',

    googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?key=&sensor=false&extension=.js',

    spinnerOpts: {
          lines: 9 ,
          length: 24 ,
          width: 13 ,
          radius: 21 ,
          scale: 0.25 ,
          corners: 1 ,
          color: '#30c58e',
          opacity: 0.2 ,
          rotate: 0 ,
          direction: 1 ,
          speed: 1.1 ,
          trail: 51 ,
          fps: 20 ,
          className: 'spinner',
          top: '50%' ,
          left: '50%' ,
          shadow: false ,
          hwaccel: false ,
          position: 'absolute',
    },

    // VARIABLES
    screenXsMax: 767, // WARNING: must be same as $screen-xs-max bootstrap variable,
    resizeTimeout: 50, // Window resize script execution delay ms
};

// HELPER FUNCTIONS

var fs = {

    resetPusher: function() {
        if ($(window).width() > s.screenXsMax) {
            fs.closePusher();
        }
    },

    openPusher: function() {
        $(s.mobileMenuSelector).addClass(s.pushedClass);
        $(s.pusherSelector).addClass(s.pushedClass);
        $(s.navbarMobileSelector).addClass(s.pushedClass);
    },

    closePusher: function() {
        $(s.mobileMenuSelector).removeClass(s.pushedClass);
        $(s.pusherSelector).removeClass(s.pushedClass);
        $(s.navbarMobileSelector).removeClass(s.pushedClass);
    },

    togglePusher: function() {
        $(s.mobileMenuSelector).toggleClass(s.pushedClass);
        $(s.pusherSelector).toggleClass(s.pushedClass);
        $(s.navbarMobileSelector).toggleClass(s.pushedClass);
    },

    adjustWindowHeight: function() {
        if ($(window).width() <= s.screenXsMax) {
            $(s.mainContentSelector).height($(window).height() - $('header').height());
        } else {
            $($(s.mainContentSelector).height('100%'));
        }
    },

    slideToggle: function() {
        $(s.desktopMenuSlideSelector).toggleClass(s.slideClass);
        $(s.lineSelector).toggleClass(s.transformClass);
        $(s.sliderSelector).removeClass(s.slideClass);
    },

    slideIn: function() {
        $(s.desktopMenuSlideSelector).addClass(s.slideClass);
        $(s.lineSelector).addClass(s.transformClass);
    },

    slideOut: function() {
        $(s.desktopMenuSlideSelector).removeClass(s.slideClass);
        $(s.lineSelector).removeClass(s.transformClass);
    },

    ajaxOpenBox: function(href, counter, ajaxWrapperClass) {
        var $ajaxWrapper = $(s.ajaxWrapperSelector+'.'+ajaxWrapperClass);
        $(s.bodySelector).addClass(s.unscrollableClass);

        if ($(window).width() <= s.screenXsMax) {
            $ajaxWrapper.html("");
        }

        $ajaxWrapper.addClass(s.slideClass);
        $ajaxWrapper.find(s.ajaxArticleBodyOverflowSelector).height($(window).height());
        $ajaxWrapper.find(s.ajaxArticleBodyOverflowSelector).addClass(s.scrollableClass);
        $ajaxWrapper.find(s.backSelector).hide();
        $ajaxWrapper.find(s.closeAjaxSelector).addClass(s.openClass);

        jQuery.get(href, {}, function(data) {
            var $content = $(data).find(s.articleBodyOverflowSelector);
            var title = $content.find(s.titleSelector).first().text();
            $ajaxWrapper.html($content.fadeIn(500));
            manualStateChange = false;
            var currentState = History.getState();
            History.pushState({type: 'ajaxOpen', level: counter, parentId: currentState.id}, title, href);
        });
    },

    ajaxCloseBox: function(ajaxClass) {
        var $ajaxWrapper = $(s.ajaxWrapperSelector+'.'+ajaxClass);
        if ($(window).width() <= s.screenXsMax)
            $ajaxWrapper.html("");
        $(s.bodySelector).removeClass(s.unscrollableClass);
        $ajaxWrapper.find(s.ajaxArticleBodyOverflowSelector).height('100%');
        $ajaxWrapper.find(s.ajaxArticleBodyOverflowSelector).removeClass(s.scrollableClass);
        $ajaxWrapper.removeClass(s.slideClass).one('transitionend', function() {
            $ajaxWrapper.html("");
        });
        $ajaxWrapper.find(s.closeAjaxSelector).removeClass(s.openClass);
    },

    ajaxAdjustBoxHeight: function() {
        if ($(s.ajaxWrapperSelector).hasClass(s.slideClass)) {
            $(s.ajaxArticleBodyOverflowSelector).height($(window).height());
        }
    },

    ajaxLoad: function(href, callback, updateHistory) {
        jQuery.get(href).done(function(response) {
            //var $arrow = $('#arrow-down').addClass('none');
            //spinner = new Spinner(s.spinnerOpts).spin($arrow.get(0));

            // PARSE NEW CONTENT
            var $content = $(response).find(s.siteContentSelector);
            var $store = $content.find(s.ajaxStoreSelector);

            // 1. REPLACE ARTICLE CONTENT
            $(s.siteContentSelector).replaceWith($content);

            var pageTitle = $store.data('page-title');
            var pageClass = $store.data('page-class');

            // 2. REPLACE PAGE TITLE
            $('title').text(pageTitle);
            $('body').attr('class', pageClass);

            // 3. CHANGE LARGE BANNER TEXT
            var $verticalBanner = $(response).find(s.verticalBannerSelector);
            $(document).find(s.verticalBannerSelector).replaceWith($verticalBanner);

            // 4. CHANGE MOBILE BANNER TEXT
            var $horizontalBanner = $(response).find(s.horizontalBannerSelector);
            $(document).find(s.horizontalBannerSelector).replaceWith($horizontalBanner);

            // 5. INITIALIZE GOOGLE MAP IF IN CONTACT
            if (pageClass == s.contactPageClass) {
                fs.loadGoogleMapApi(fs.mapInit);
            }

            // 6. RE-INITIALIZE ALL SCRIPTS
            fs.initialize();
            fs.loadImages();

            // 7. UPDATE HISTORY
            if (updateHistory) {
                manualStateChange = false;
                History.pushState({type: "ajaxNext"}, pageTitle, href);
            }

            // 8. IF DEFINED RUN CALLBACK
            if (typeof callback == 'function') {
              callback();
            }
        });
    },

    relatedRowEquilizer: function() {
        var maxHeight = 0;
        $(s.newsRowSelector).each(function(i, item) {
            var childrenHeight = $(item).find(s.titleSelector).outerHeight();
            if (childrenHeight > maxHeight) {
                maxHeight = childrenHeight;
            }
        });
        $(s.newsRowSelector).each(function(i, item) {
            $(item).height(maxHeight);
        });
    },

    lawyerRowEquilizer: function() {
        var maxHeight = 0;
        $(s.lawyerRowSelector).imagesLoaded(function() {
            $(s.lawyerRowSelector).css('height', 'auto');
            $(s.lawyerRowSelector).each(function(i, item) {
                var height = $(item).height();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            $(s.lawyerRowSelector).each(function(i, item) {
                $(item).height(maxHeight);
            });
        });
    },

    heroBackgroundHeight: function() {
        $(s.heroBackgroundSelector).height($(window).height());
    },

    loadGoogleMapApi: function(callback) {
        $.getScript(s.googleMapApiUrl, callback);
    },

    // MAP BUILDER URL: https://mapbuildr.com/buildr/3pw7ur
    mapInit: function() {

        // MAP OPTIONS
        var mapOptions = {
            center: new google.maps.LatLng(37.94445, 23.698383),
            zoom: 15,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
            },
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            scaleControl: false,
            scrollwheel: false,
            panControl: true,
            streetViewControl: false,
            draggable: true,
            overviewMapControl: true,
            overviewMapControlOptions: {
                opened: false,
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        }

        // BIND MAP TO HTML
        var mapElement = document.getElementById('map');
        var map = new google.maps.Map(mapElement, mapOptions);


        // MAP LOCATIONS
        var locations = [
            [
                'A.S Papadimitriou & Partners',
                'A.S. Papadimitriou & Partners is a distinguished law firm offering a wide range of comprehensive legal services in the field of business and civil law.',
                '+30 210 94 09 960/961/962/042',
                'office@saplegal.gr',
                'saplegal.gr',
                37.942961,
                23.699257,
                '/static/img/marker.png'
            ]
        ];

        // EXTRACT POSITIONAL ARGUMENTS OF EACH LOCATION TO VARIABLES
        for (i = 0; i < locations.length; i++) {
            if (locations[i][1] == 'undefined') {
                description = '';
            } else {
                description = locations[i][1];
            }
            if (locations[i][2] == 'undefined') {
                telephone = '';
            } else {
                telephone = locations[i][2];
            }
            if (locations[i][3] == 'undefined') {
                email = '';
            } else {
                email = locations[i][3];
            }
            if (locations[i][4] == 'undefined') {
                web = '';
            } else {
                web = locations[i][4];
            }
            if (locations[i][7] == 'undefined') {
                markericon = '';
            } else {
                markericon = locations[i][7];
            }
            marker = new google.maps.Marker({
                icon: markericon,
                position: new google.maps.LatLng(locations[i][5], locations[i][6]),
                map: map,
                title: locations[i][0],
                desc: description,
                tel: telephone,
                email: email,
                web: web
            });
            if (web.substring(0, 7) != "http://") {
                link = "http://" + web;
            } else {
                link = web;
            }
            bindInfoWindow(marker, map, locations[i][0], description, telephone, email, web, link);
        }


        // BIND INFO WINDOW TO LOCATIONS
        function bindInfoWindow(marker, map, title, desc, telephone, email, web, link) {

            // Check if info window is visible
            var infoWindowVisible = (function() {
                var currentlyVisible = false;
                return function(visible) {
                    if (visible !== undefined) {
                        currentlyVisible = visible;
                    }
                    return currentlyVisible;
                };
            }());

            // Create new info windw
            iw = new google.maps.InfoWindow();

            // OPEN MAP EVENT LISTENER <MARKER CLICK>
            google.maps.event.addListener(marker, 'click', function() {

                if (infoWindowVisible()) {
                    iw.close();
                    infoWindowVisible(false);
                } else {
                    var html = $('#info-window').html();
                    iw = new google.maps.InfoWindow({
                        content: html
                    });
                    iw.open(map, marker);
                    infoWindowVisible(true);
                }

            });

            // CLOSE MAP EVENT LISTENER <CLOSE CLICK>
            google.maps.event.addListener(iw, 'closeclick', function() {
                infoWindowVisible(false);
            });
        }
    },

    loadImages: function() {
        $(s.homeMainContentSelector).imagesLoaded({background: true}, function() {
            $(this.elements[0]).addClass(s.fadeInClass);
        });

        $(s.verticalBannerSelector).imagesLoaded({background: true}, function() {
            $(this.elements[0]).addClass(s.fadeInClass);
        });

        $(s.horizontalBannerSelector).imagesLoaded({background: true}, function() {
            $(this.elements[0]).addClass(s.fadeInClass);
        });

        $(s.siteContentSelector).imagesLoaded(function() {
            $(this.elements[0]).addClass(s.fadeInClass);
            $(s.loadingSelector).addClass(s.hideClass);
            setTimeout(function() {
                fs.slideOut();
                fs.closePusher();
            }, 500);
            spinner.stop();
        });
    },

    initialize: function() {
        fs.adjustWindowHeight();
        fs.resetPusher();
        fs.relatedRowEquilizer();
        fs.lawyerRowEquilizer();
        fs.heroBackgroundHeight();
        fs.ajaxAdjustBoxHeight();
    }
};


// JQUERY FUNCTIONS

jQuery.fn.extend({

    getMaxChildrenHeight: function() {
      var max_height = 0;
      var $list = $(this).find('> *');
      $list.each(function(i, node) {
        if ($(node).height() > max_height)
            max_height = $(node).height();
      });
      return max_height;
    },

    inheritMaxChildrenHeight: function() {
      var $self = $(this);
      $self.height($self.getMaxChildrenHeight());
    }
});


// DOCUMENT READY

jQuery(document).ready(function($) {

    spinner = new Spinner(s.spinnerOpts).spin($(s.mainContentSelector).get(0));

    // INITIAL FUNCTION CALLS
    fs.initialize();
    fs.loadImages();

    if ($(s.bodySelector).hasClass(s.contactPageClass)) {
        fs.loadGoogleMapApi(fs.mapInit);
    }

    // Disable -webkit-overflow-scrolling: touch on IOS7 because of isses
    if (navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i)) {
        $(s.mainContentSelector).css('-webkit-overflow-scrolling', 'auto');41
    }

    // OPEN MOBILE MENU <CLICK, TOUCH>
    $(document).on('click touchstart', s.openMobileSelector, function(e) {
        e.preventDefault();
        fs.togglePusher();
        fs.slideToggle();
    });

    // OPEN DESKTOP MENU <CLICK, TOUCH>
    $(document).on('click touchstart', s.openDesktopSelector, function(e) {
        e.preventDefault();
        fs.slideToggle();
    });

    // MENU SLIDE IN ELEMENTS <MOUSENTER>
    $(document).on('mouseenter', s.desktopMenuItemSelector, function(e) {
        var $self = $(this);
        var $slider = $self.siblings(s.sliderSelector);
        $(s.sliderSelector).removeClass(s.slideClass);
        $slider.addClass(s.slideClass);
    });

    // MENU SLIDE OUT ELEMENTS <MOUSELEAVE>
    $(document).on('mouseleave', s.itemSelector, function(e) {
        var $self = $(this);
        $(s.sliderSelector).removeClass(s.slideClass);
    });

    // SOCIAL SHARE
    $(document).on('click touchstart', s.socialLinkSelector, function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        window.open(href, $('head title').text(),'height=573, width=558');
    });

    // OPEN AJAX BOX
    var counter = 0;
    $(document).on('click', s.listItemSelector, function(e) {
        e.preventDefault();
        counter++;
        var href = $(this).attr('href');
        var ajaxWrapperClass = $(this).data('ajax');
        fs.ajaxOpenBox(href, counter, ajaxWrapperClass);
    });

    // NEXT PAGE AJAX
    $(document).on('click', s.ajaxClickSelectors, function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        spinner = new Spinner(s.spinnerOpts).spin($(s.mainContentSelector).get(0));
        fs.ajaxLoad(href, function() {
            $(s.mainContentSelector).scrollTop(0);
        }, true);
    });

    // CLOSE AJAX BOX <CLICK OUTSITE AJAX BOX>
    $(document).on('click', s.primaryArticleBodySelector, function(e) {
        //fs.ajaxCloseBox();
    });

    // CLOSE AJAX BOX <CLICK CLOSE BUTTON>
    $(document).on('click touchstart', s.closeAjaxSelector, function(e) {
        e.preventDefault();
        var $self = $(e.target);
        var ajaxWrapperClass = $self.parents(s.ajaxWrapperSelector).data('ajax');
        fs.ajaxCloseBox(ajaxWrapperClass);
        var State = History.getState();
        if (State.data.type == 'ajaxOpen') {
            manualStateChange = false;
            History.back();
        }
    });

    // CLOSE AJAX BOX <ESC KEY PRESS>
    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            var $lastAjaxWrapper = $(s.ajaxWrapperSelector+'.'+s.slideClass).last();
            var ajaxWrapperClass = $lastAjaxWrapper.data('ajax');
            fs.ajaxCloseBox(ajaxWrapperClass);
            var State = History.getState();
            if (State.data.type == 'ajaxOpen') {
                manualStateChange = false;
                History.back();
            }
        }
    });

    History.Adapter.bind(window, 'statechange', function(e) {
        var State = History.getState();
        var type = State.data.type;

        if (manualStateChange == true) { // Back button pressed
            var $lastAjaxWrapper = $(s.ajaxWrapperSelector+'.'+s.slideClass).last();
            var ajaxWrapperClass = $lastAjaxWrapper.data('ajax');
            var ajaxIsOpen = $(s.ajaxWrapperSelector).hasClass(s.slideClass);
            fs.ajaxCloseBox(ajaxWrapperClass);

            if (!ajaxIsOpen) {
                var $store = $(s.siteContentSelector).find(s.ajaxStoreSelector);
                var previousUrl = $store.data('previousUrl');
                fs.ajaxLoad(window.location.href);
            }
        }

        manualStateChange = true;
    });


    // SCROLL ANIMATE
    $(document).on('click', s.moreSelector, function(e) {
        e.preventDefault();
        $(s.mainContentSelector).animate({
            scrollTop: $(s.heroBackgroundSelector).height()
        }, 900, 'easeInOutQuint');
    });

    // NEWS LIST AJAX
    var pageCount = 1;
    $(document).on('click', s.loadMoreSelector, function(e) {
        e.preventDefault();
        var href = window.location.href;
        pageCount++;
        jQuery.get(href, {p: pageCount}).done(function(response) {
            var $response = $(response);
            var $list = $response.find(s.postListNewsSelector);
            var $items = $list.find(s.newsItemSelector);
            $(document).find(s.postListNewsSelector)
                .append($items.hide().fadeIn(500));
            })
            .fail(function() {
                $(s.loadMoreSelector).fadeOut();
            });
    });

    // WINDOW RESIZE
    timeout = function(){};
    $(window).on('resize', function(e) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fs.initialize();
        }, s.resizeTimeout);
    });
});


})(jQuery, this, this.document, window.s);
